"use strict";

export class AnalyticsEvents {
    defaultValues = {
        id: 'page',
        label: 'click',
        pageUrl: location.href
    };

    timeout = 2000;

    constructor(args = {}) {
        if (args.defaultValues) {
            this.defaultValues = { ...this.defaultValues, ...args.defaultValues };
        }

        if (args.timeout) {
            this.timeout = args.timeout;
        }

        this.bind();
    }

    bind() {
        document.addEventListener('click', this.onDocumentClick);
    }

    hasAnalyticsConsent() {
        return (typeof Cookiebot !== 'undefined') ? Cookiebot.consent?.statistics : true;
    }

    getPayload(el) {
        const payload = {};

        if (el.id) {
            payload.id = el.id;
        } else if (el.getAttribute('data-id')) {
            payload.id = el.getAttribute('data-id');
        }

        if (el.textContent?.trim()) {
            payload.label = el.textContent.trim();
        } else if (el.ariaLabel) {
            payload.label = el.ariaLabel;
        } else if (el.title) {
            payload.label = el.title;
        }

        if (el.href) {
            payload.linkUrl = el.href;

            const target = el.target || '_self';

            if (!el.href.startsWith('#') && target !== '_blank') {
                const href = el.href;
                let navigated = false;

                const navigate = () => {
                    if (navigated) return;
                    navigated = true;

                    switch (target) {
                        case '_parent':
                            window.parent.location.href = href;
                            break;
                        case '_top':
                            window.top.location.href = href;
                            break;
                        default:
                            window.location.href = href;
                            break;
                    }
                };

                payload.eventCallback = navigate;
                payload.eventTimeout = this.timeout;
            }
        }

        return payload;
    }

    getPayloadDataAttributes(el) {
        const payload = {};
        
        for (const attr of el.attributes) {
            if (!attr.name.startsWith('data-layer-') || attr.value === '') {
                continue;
            }

            const key = attr.name.replace('data-layer-', '').replace(/-([a-z])/g, (_, char) => char.toUpperCase());

            payload[key] = attr.value;
        }

        return payload;
    }

    onDocumentClick = (event) => {
        if (typeof window.dataLayer === 'undefined' || !this.hasAnalyticsConsent()) {
            return;
        }

        const clickTarget = event.target.closest('[data-layer-event]');

        if (!clickTarget) {
            return;
        }

        const payload = {
            ...this.defaultValues,
            ...this.getPayload(clickTarget),
            ...this.getPayloadDataAttributes(clickTarget)
        };

        if (payload.eventCallback) {
            event.preventDefault();
        }

        window.dataLayer.push(payload);

        if (payload.eventCallback) {
            setTimeout(payload.eventCallback, this.timeout);
        }
    }
}